import { FC } from "react";
import { useTranslation } from "react-i18next";
import ImageWithEmptyFallback from "@Components/ImageWithEmptyFallback/ImageWithEmptyFallback";
import { RedemptionChannelTag } from "src/components";
import GiftcardHtml from "src/Modules/GiftCards/pages/GiftcardDetails/components/GiftcardHtml/GiftcardHtml";
import { DiscountItemType } from "src/Modules/Discounts/types";
import { formatNumber } from "src/utility";

type Props = {
  data: DiscountItemType | undefined;
  imageUrl: string | undefined;
  brandName?: string;
};

const DiscountDetailsCard: FC<Props> = ({ data, imageUrl, brandName }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap items-start justify-between gap-3 md:gap-4">
        <div className="flex flex-1 items-center gap-2 md:gap-4">
          <ImageWithEmptyFallback
            src={imageUrl}
            alt={brandName}
            className="size-20! max-w-20! md:size-28! md:max-w-28! outline-border-subtle aspect-square shrink-0 rounded-sm object-cover p-2 outline"
          />
          <div className="flex flex-col gap-1">
            <span className="text-font-default text-base font-bold md:text-2xl">{brandName}</span>
            <span className="text-font-subtle whitespace-nowrap text-sm">
              {t("Discounts.amount")}
              <span className="text-font-active font-semibold">
                {formatNumber(data?.totalPrice)} {data?.currency ?? t("Discounts.currencyFallback")}
              </span>
            </span>
          </div>
        </div>
        {data?.redemptionChannel && (
          <RedemptionChannelTag
            channel={data.redemptionChannel}
            label={t(`Discounts.redemptionChannels.${data.redemptionChannel}`, data.redemptionChannel)}
          />
        )}
      </div>
      {data?.description && <GiftcardHtml html={data.description} className="text-sm text-font-subtle flex flex-col gap-2" />}
    </div>
  );
};

export default DiscountDetailsCard;
